import UploadMedia from './src/upload-media.vue'

UploadMedia.install = function(Vue) {
  Vue.component(UploadMedia.name, UploadMedia)
}

export default UploadMedia
